module.exports = __webpack_public_path__ + "static/img/get_over_status.1d905799.png";